import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
import { createStore, createStyleSet } from 'botframework-webchat';  
import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import WebChat from './WebChat';
import IframeComponent from './IframeComponent';
import './fabric-icons-inline.css';
import './MinimizableWebChat.css';
const cookies = new Cookies();
const MinimizableWebChat = () => {
  const store = useMemo(
    () =>
      createStore({}, ({ dispatch }) => next => action => {
        console.log('action--->',action);
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
          dispatch({
            type: 'WEB_CHAT/SEND_EVENT',
            payload: {
              name: 'webchat/join',
              value: {
                language: window.navigator.language
              }
            }
          });
        } else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {  
          console.log('action.type',action.payload);
          if(action.payload.activity.name == "closehealtbot"){
            closeBut(true);
          }
            
          if (action.payload.activity.from.role === 'bot') {
            setNewMessage(true);
          }
        }else if (action.type == "DIRECT_LINE/POST_ACTIVITY") {
          // console.log("inside post")
          if (action.payload.activity && action.payload.activity.value && action.payload.activity.value.msteams && action.payload.activity.value.msteams.type == "invoke") {
            console.log("inside task modu",action.payload.activity.value);
            let data = action.payload.activity.value;
            delete data.msteams.value.platform;delete data.msteams.value.hiddenKey;delete data.msteams.value.type;
            let querys = '';
            for (var i of Object.keys(data.msteams.value)) {
              querys += `${i}=${encodeURIComponent(data.msteams.value[i])}&`
            }
            if (data.msteams.value.intent == "Work From Office") {            
              // console.log('--------------->in');
              for (var i of Object.keys(data)) {
                querys += `${i}=${encodeURIComponent(data[i])}&`
              }             
            }
            // fetch('https://isgchatbot.azure-api.net/V1-clone/addUsers', { method: 'POST', body: JSON.stringify(action.payload.activity.value), headers: {"Content-Type": "application/json"}})
            fetch(`https://isgchatbot.azure-api.net/V1-clone/art/enroll?${querys}`, { method: 'GET' })
              .then(function (response) {
                return response.json()
              })
              .then(body => {
                console.log("response", body.taskmoduleUrl)
                taskModule(body.taskmoduleUrl)
                closeBut(false);
              })
          }
        }        
        return next(action);
      }),
    []
  );

  const styleSet = useMemo(
    () =>
      createStyleSet({
        backgroundColor: 'Transparent'
      }),
    []
  );

  const [loaded, setLoaded] = useState(true);
  const [minimized, setMinimized] = useState(false);
  const [newMessage, setNewMessage] = useState(false);
  const [side, setSide] = useState('right');
  const [token, setToken] = useState();
  const [isModalOpen, closeBut] = useState(true);
  const [taskmoduleUrl, taskModule] = useState();
  // To learn about reconnecting to a conversation, see the following documentation:
  // https://docs.microsoft.com/en-us/azure/bot-service/rest-api/bot-framework-rest-direct-line-3-0-reconnect-to-conversation?view=azure-bot-service-4.0

  const handleFetchToken = useCallback(async () => {
    if (!token) {
      if (!cookies.get('user_id')) cookies.set('user_id', uuidv4(), { path: '/' })
        let user_id = cookies.get('user_id');

      const res = await fetch('https://isgchatbot.azure-api.net/V1-clone/directline/token?user_id='+user_id, { method: 'POST'});
      const { token } = await res.json();
      console.log("token", JSON.stringify(token));
      console.log('********');
    //  let botToken = "ew0KICAiYWxnIjogIlJTMjU2IiwNCiAgImtpZCI6ICJsY0oxTXFpNkdKYXdCZEw5Y0dieEt5S1R6OE0iLA0KICAieDV0IjogImxjSjFNcWk2R0phd0JkTDljR2J4S3lLVHo4TSIsDQogICJ0eXAiOiAiSldUIg0KfQ.ew0KICAiYm90IjogImhuaWNvcnBjb2NvIiwNCiAgInNpdGUiOiAiVW12RmltYWQ1RFEiLA0KICAiY29udiI6ICIyYk12cTJodDFsR0dEZDk0eHA4WXpLLWsiLA0KICAidXNlciI6ICJkbF8yYzkxZTU2Zi1jNTBjLTRmM2ItYjNhNi0wZjk3MmY1MmM2ZTIiLA0KICAib3JpZ2luIjogWw0KICAgICJodHRwczovL2hlbWFhcGltZ210LmF6dXJlLWFwaS5uZXQvIiwNCiAgICAiaHR0cHM6Ly9pc2djaGF0Ym90LmF6dXJlLWFwaS5uZXQvIiwNCiAgICAiaHR0cHM6Ly9mYjBlYTViYWI2ZWMubmdyb2suaW8vIiwNCiAgICAiaHR0cDovL2xvY2FsaG9zdDo4MDAwIg0KICBdLA0KICAibmJmIjogMTYxMTU2ODgzOSwNCiAgImV4cCI6IDE2MTE1NzI0MzksDQogICJpc3MiOiAiaHR0cHM6Ly9kaXJlY3RsaW5lLmJvdGZyYW1ld29yay5jb20vIiwNCiAgImF1ZCI6ICJodHRwczovL2RpcmVjdGxpbmUuYm90ZnJhbWV3b3JrLmNvbS8iDQp9.GcbUtiI5s0jKqztZIh9hibFGvH_aKJ61hyumiInSv7QkbJYUv9HIMQ_L0zjwON0SbDnOWto9K01XZhb4ZMA7BbpxXS2TuRVINRLLCRgI9YflNOSIxsP0hg8nnXmpR2NcxV906i0B5p0SO5NOcAZOH2IGk1UMvIxp2eZYH8cEV1KDh4dH9D9oPjuYqHvQj_5nNetoOIScRfjvAohHcDj6NYBi0-QHQO4oCnwAGVaD4mkJoV44xYOQsD4KcEljFo4yMWo7KbjPDg7H3h7VHwsEay7xXTNQoz93oGsBQYNFKpT2WMoOe2GAPMVW7Jhkz-MAuF_EXbeDn7M1w9APFCkchw"
      setToken(token);
    }
  }, [setToken, token]);

  const handleMaximizeButtonClick = useCallback(async () => {
    setLoaded(true);
    setMinimized(false);
    setNewMessage(false);
  }, [setMinimized, setNewMessage]);

  const handleMinimizeButtonClick = useCallback(() => {
    setMinimized(true);
    setNewMessage(false);
  }, [setMinimized, setNewMessage]);

  const handleSwitchButtonClick = useCallback(() => {
    setSide(side === 'left' ? 'right' : 'left');
  }, [setSide, side]);

  var handleAdd = useCallback(async () => {
    closeBut(true);
    taskModule("")
  }, [closeBut]);
  // TODO: [P2] Currently, we cannot unmount Web Chat from DOM when it is minimized.
  //       Today, if we unmount it, Web Chat will call disconnect on DirectLineJS object.
  //       When minimized, we still want to maintain that connection while the UI is gone.
  //       This is related to https://github.com/microsoft/BotFramework-WebChat/issues/2750.

  return (
    <div className="minimizable-web-chat">
     {minimized && (
        <button className="maximize" onClick={handleMaximizeButtonClick}>
          <span className={token ? 'ms-Icon ms-Icon--MessageFill' : 'ms-Icon ms-Icon--Message'} />
          {newMessage && <span className="ms-Icon ms-Icon--CircleShapeSolid red-dot" />}
        </button>
      )} 
      {loaded && (
        <div className={classNames(side === 'left' ? 'chat-box left' : 'chat-box right', minimized ? 'hide' : '')}>
          <header>
            <div className="filler">
              <img style= { {padding: '8px' } } alt="Logo" src="https://isgchatbot.azure-api.net/V1-clone/getImages?file=webchatLogo.png"></img>
            </div>
            {/* <button className="switch" onClick={handleSwitchButtonClick}>
              <span className="ms-Icon ms-Icon--Switch" />
            </button>
            <button className="minimize" onClick={handleMinimizeButtonClick}>
              <span className="ms-Icon ms-Icon--ChromeMinimize" />
            </button>  */}
          </header> 
          {true && (
            <div style={isModalOpen ? { display: 'none' } : { display: 'block', height: '100%' }}>
              <button onClick={handleAdd} className="btncancel" > &#10006; </button>
              <IframeComponent src={taskmoduleUrl} height="100%" width="100%" />
            </div>
          )}
          <WebChat
            className="react-web-chat"
            onFetchToken={handleFetchToken}
            store={store}
            styleSet={styleSet}
            token={token}
          />
        </div>
      )}
    </div>
  );
};

export default MinimizableWebChat;



